import { getWorldsDomain } from '@/lib/configs'
import { Room } from '@/services/cms'

type EmbedOptions = {
  width?: number
  height?: number
  frameBorder?: number
  allowfullscreen?: boolean
}

type EmbedQueryParams = string | { name: string; value?: string }

export const createEmbedCode = (
  info: Partial<Room>,
  queryParams: EmbedQueryParams[] = [],
  options: EmbedOptions = {},
) => {
  const { width = 970, height = 600, frameBorder = 0, allowfullscreen = true } = options

  const worldsDomain = `https://${getWorldsDomain()}`
  const baseUrl = new URL(`${worldsDomain}/${info.hub_sid}`)

  queryParams.forEach((param) => {
    if (typeof param === 'string') {
      baseUrl.searchParams.set(param, '')
    } else if (param && typeof param === 'object') {
      const { name, value } = param
      if (name) baseUrl.searchParams.set(name, value || '')
    }
  })

  return `<iframe width="${width}" height="${height}" src="${
    baseUrl.href
  }" title="${info.title}" frameborder="${frameBorder}"${
    allowfullscreen ? ' allowfullscreen' : ''
  }></iframe>`
}
